var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.537,
    height: 17.653,
    viewBox: "0 0 23.537 17.653",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "iconmonstr-youtube-6_1_",
    "data-name": "iconmonstr-youtube-6 (1)",
    d: "M19.236,3.18C15.7,2.939,7.83,2.94,4.3,3.18.479,3.441.028,5.75,0,11.826c.028,6.066.475,8.384,4.3,8.646,3.531.24,11.4.241,14.936,0,3.822-.261,4.272-2.569,4.3-8.646C23.508,5.761,23.062,3.442,19.236,3.18ZM8.826,15.749V7.9l7.846,3.916Z",
    transform: "translate(0 -3)",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.0682ff229db68a24ba03501af5d3ff17.svg";
export { ForwardRef as ReactComponent };